// Strains interactions shared by strains and strains-info sections

/**
 * @param {HTMLElement} button
 * @param {boolean} isExpanded
 */
function updateStrainBlendIcon(button, isExpanded) {
  const icon = button.querySelector('.strain-blend-icon');
  if (!icon) return;
  
  // Get block ID from the button's aria-controls or parent element
  const controlsId = button.getAttribute('aria-controls');
  const blockId = controlsId ? controlsId.replace('strain-blend-', '') : 'default';
  
  if (isExpanded) {
    // Show minus icon (horizontal line only)
    icon.innerHTML = `
      <g clip-path="url(#clip0_minus_${blockId})">
        <path d="M3.75 12H20.25" stroke="#1C3660" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
      </g>
      <defs>
        <clipPath id="clip0_minus_${blockId}">
          <rect width="24" height="24" fill="white"/>
        </clipPath>
      </defs>
    `;
  } else {
    // Show plus icon (both lines)
    icon.innerHTML = `
      <g clip-path="url(#clip0_plus_${blockId})">
        <path d="M3.75 12H20.25" stroke="#1C3660" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M12 3.75V20.25" stroke="#1C3660" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
      </g>
      <defs>
        <clipPath id="clip0_plus_${blockId}">
          <rect width="24" height="24" fill="white"/>
        </clipPath>
      </defs>
    `;
  }
}

/**
 * @param {HTMLElement} button
 */
function toggleStrainBlend(button) {
  const isExpanded = button.getAttribute('aria-expanded') === 'true';
  const controlsId = button.getAttribute('aria-controls');
  if (!controlsId) return;
  const content = document.getElementById(controlsId);
  if (!content) return;

  const newExpanded = !isExpanded;
  // Close all other strain-blend accordions
if (newExpanded) {
  document.querySelectorAll('.strain-blend-toggle').forEach((otherBtn) => {
    if (otherBtn !== button) {
      otherBtn.setAttribute('aria-expanded', 'false');
      const otherControls = otherBtn.getAttribute('aria-controls');
      const otherContent = document.getElementById(otherControls);
      if (otherContent) {
        otherContent.hidden = true;
      }
      updateStrainBlendIcon(otherBtn, false);
    }
  });
}

  button.setAttribute('aria-expanded', String(newExpanded));
  content.hidden = isExpanded;

  // Update icon based on new state
  updateStrainBlendIcon(button, newExpanded);

  if (!isExpanded) {
    content.addEventListener('keydown', handleStrainBlendEscapeKey);
  } else {
    content.removeEventListener('keydown', handleStrainBlendEscapeKey);
  }
}

/**
 * @param {KeyboardEvent} event
 */
function handleStrainBlendEscapeKey(event) {
  if (event.key !== 'Escape') return;
  const content = /** @type {HTMLElement} */ (event.currentTarget);
  const button = /** @type {HTMLElement} */ (document.querySelector(`[aria-controls='${content.id}']`));
  if (!button) return;
  button.setAttribute('aria-expanded', 'false');
  content.hidden = true;
  updateStrainBlendIcon(button, false);
  button.focus();
  content.removeEventListener('keydown', handleStrainBlendEscapeKey);
}

/**
 * @param {HTMLElement} button
 * @param {boolean} isExpanded
 */
function updateAccordionIcon(button, isExpanded) {
  const iconContainer = button.querySelector('.strains-dialog__accordion-icon');
  if (!iconContainer) return;
  
  let icon = iconContainer.querySelector('svg');
  if (!icon) {
    // Create SVG if it doesn't exist
    icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    icon.setAttribute('width', '24');
    icon.setAttribute('height', '24');
    icon.setAttribute('viewBox', '0 0 24 24');
    icon.setAttribute('fill', 'none');
    icon.setAttribute('aria-hidden', 'true');
    iconContainer.appendChild(icon);
  }

  if (isExpanded) {
    // Show minus icon (horizontal line)
    icon.innerHTML = '<path d="M6 12H18" stroke="#1C3660" stroke-width="1.5" stroke-linecap="round"/>';
  } else {
    // Show plus icon (cross)
    icon.innerHTML = '<path d="M12 6V18M6 12H18" stroke="#1C3660" stroke-width="1.5" stroke-linecap="round"/>';
  }
}

/**
 * @param {HTMLElement} button
 */
function toggleDialogAccordion(button) {
  const isExpanded = button.getAttribute('aria-expanded') === 'true';
  const controlsId = button.getAttribute('aria-controls');
  if (!controlsId) {
    console.warn('Accordion button missing aria-controls:', button);
    return;
  }
  const content = document.getElementById(controlsId);
  if (!content) {
    console.warn('Accordion content not found:', controlsId);
    return;
  }

  const newExpanded = !isExpanded;
  // Close all other accordions in the same dialog
if (newExpanded) {
  const dialog = button.closest('dialog.strains-dialog');
  if (dialog) {
    dialog.querySelectorAll('.strains-dialog__accordion-button, .strains-dialog__supplement-toggle')
      .forEach((otherBtn) => {
        if (otherBtn !== button) {
          otherBtn.setAttribute('aria-expanded', 'false');
          const otherId = otherBtn.getAttribute('aria-controls');
          const otherContent = document.getElementById(otherId);
          if (otherContent) {
            otherContent.setAttribute('hidden', '');
          }
          updateAccordionIcon(otherBtn, false);
        }
      });
  }
}

  button.setAttribute('aria-expanded', String(newExpanded));
  
  // Toggle visibility
  if (newExpanded) {
    content.removeAttribute('hidden');
  } else {
    content.setAttribute('hidden', '');
  }
  
  updateAccordionIcon(button, newExpanded);

  if (newExpanded) {
    content.addEventListener('keydown', handleStrainBlendEscapeKey);
  } else {
    content.removeEventListener('keydown', handleStrainBlendEscapeKey);
  }
}

// Initialize accordion icons for all accordion buttons
function initializeAccordionIcons() {
  document.querySelectorAll('.strains-dialog__accordion-button, .strains-dialog__supplement-toggle').forEach((button) => {
    const btn = /** @type {HTMLElement} */ (button);
    const isExpanded = btn.getAttribute('aria-expanded') === 'true';
    updateAccordionIcon(btn, isExpanded);
  });
}

/**
 * Check if current viewport is mobile
 * @returns {boolean}
 */
function isMobileViewport() {
  return window.matchMedia('(max-width: 768px)').matches;
}

/**
 * Initialize accordion states based on viewport (desktop vs mobile)
 */
function initializeAccordionStates() {
  const isMobile = isMobileViewport();
  
  // Handle main section strain blends
  document.querySelectorAll('.strain-blend-toggle').forEach((button) => {
    const btn = /** @type {HTMLElement} */ (button);
    const mobileExpanded = btn.getAttribute('data-default-expanded-mobile') === 'true';
    const desktopExpanded = btn.getAttribute('data-default-expanded-desktop') === 'true';
    const shouldBeExpanded = isMobile ? mobileExpanded : desktopExpanded;
    
    const controlsId = btn.getAttribute('aria-controls');
    if (!controlsId) return;
    const content = document.getElementById(controlsId);
    if (!content) return;
    
    btn.setAttribute('aria-expanded', String(shouldBeExpanded));
    if (shouldBeExpanded) {
      content.removeAttribute('hidden');
    } else {
      content.setAttribute('hidden', '');
    }
    updateStrainBlendIcon(btn, shouldBeExpanded);
  });
  
  // Handle dialog accordions
  document.querySelectorAll('.strains-dialog__accordion-button, .strains-dialog__supplement-toggle').forEach((button) => {
    const btn = /** @type {HTMLElement} */ (button);
    const mobileExpanded = btn.getAttribute('data-default-expanded-mobile') === 'true';
    const desktopExpanded = btn.getAttribute('data-default-expanded-desktop') === 'true';
    const shouldBeExpanded = isMobile ? mobileExpanded : desktopExpanded;
    
    const controlsId = btn.getAttribute('aria-controls');
    if (!controlsId) return;
    const content = document.getElementById(controlsId);
    if (!content) return;
    
    btn.setAttribute('aria-expanded', String(shouldBeExpanded));
    if (shouldBeExpanded) {
      content.removeAttribute('hidden');
    } else {
      content.setAttribute('hidden', '');
    }
    updateAccordionIcon(btn, shouldBeExpanded);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  // Initialize accordion states based on viewport
  initializeAccordionStates();
  
  // Re-initialize on window resize
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      initializeAccordionStates();
    }, 150);
  });
  
  // Initialize strain blend icons on page load
  document.querySelectorAll('.strain-blend-toggle').forEach((button) => {
    const btn = /** @type {HTMLElement} */ (button);
    const isExpanded = btn.getAttribute('aria-expanded') === 'true';
    updateStrainBlendIcon(btn, isExpanded);
  });

  // Toggle buttons (main section)
  document.querySelectorAll('.strain-blend-toggle').forEach((button) => {
    const btn = /** @type {HTMLElement} */ (button);
    btn.addEventListener('click', function () {
      toggleStrainBlend(/** @type {HTMLElement} */ (this));
    });
    btn.addEventListener('keydown', function (event) {
      const e = /** @type {KeyboardEvent} */ (event);
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggleStrainBlend(/** @type {HTMLElement} */ (this));
      }
    });
  });

  // Initialize accordion icons on page load
  initializeAccordionIcons();

  // Use event delegation for all dialog interactions
  document.addEventListener('click', (event) => {
    const target = /** @type {HTMLElement | null} */ (event.target);
    if (!target) return;
    
    // Check for close button first (highest priority)
    // The form's method="dialog" will handle closing, but we need to ensure it doesn't bubble
    const closeBtn = target.closest('.strains-dialog__close-btn, [data-strains-close]');
    if (closeBtn) {
      // Don't prevent default - let the form's method="dialog" handle it
      // Just ensure focus management happens via the close event handler
      return;
    }
    
    // Check for accordion button (need to check if we're inside a dialog first)
    const dialog = /** @type {HTMLDialogElement | null} */ (target.closest('dialog.strains-dialog'));
    if (dialog && dialog.open) {
      const accordionBtn = target.closest('.strains-dialog__accordion-button, .strains-dialog__supplement-toggle');
      if (accordionBtn) {
        // Stop propagation to prevent form submission or other handlers
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        toggleDialogAccordion(/** @type {HTMLElement} */ (accordionBtn));
        return false;
      }
    }
    
    // Check for open button
    const openBtn = 'closest' in target ? /** @type {HTMLElement | null} */ (target.closest('[data-strains-open]')) : null;
    if (openBtn) {
      const id = openBtn.getAttribute('data-strains-id');
      const dlg = /** @type {HTMLDialogElement | null} */ (document.querySelector(`[data-strains-dialog='${id}']`));
      if (dlg && typeof dlg.showModal === 'function') {
        dlg.showModal();
        document.documentElement.style.overflow = 'hidden';
        // Re-initialize accordion states when dialog opens
        setTimeout(() => {
          initializeAccordionStates();
        }, 0);
        // Focus the close button for accessibility
        const closeBtn = /** @type {HTMLElement | null} */ (dlg.querySelector('.strains-dialog__close-btn'));
        if (closeBtn) {
          closeBtn.focus();
        }
      }
      return;
    }
  });

  // Keyboard events for dialog accordion buttons
  document.addEventListener('keydown', (event) => {
    const target = /** @type {HTMLElement | null} */ (event.target);
    if (!target) return;
    
    // Handle Escape key for dialog close
    if (event.key === 'Escape') {
      const dialog = target.closest('dialog.strains-dialog');
      if (dialog) {
        const dlg = /** @type {HTMLDialogElement} */ (dialog);
        if (dlg.open) {
          event.preventDefault();
          event.stopPropagation();
          dlg.close();
          // Focus and overflow handled in close event
        }
      }
    }
    
  // Handle Enter/Space for accordion buttons
  const dialog = /** @type {HTMLDialogElement | null} */ (target.closest('dialog.strains-dialog'));
  if (dialog && dialog.open) {
    const accordionBtn = target.closest('.strains-dialog__accordion-button, .strains-dialog__supplement-toggle');
    if (accordionBtn && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      event.stopPropagation();
      toggleDialogAccordion(/** @type {HTMLElement} */ (accordionBtn));
    }
  }
  });

  // Handle dialog close events (form submission, backdrop click, etc.)
  document.querySelectorAll('[data-strains-dialog]').forEach((dlg) => {
    const dialog = /** @type {HTMLDialogElement} */ (dlg);
    
    dialog.addEventListener('cancel', (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (dialog.open) {
        dialog.close();
      }
      // Focus and overflow handled in close event
    });
    
    dialog.addEventListener('close', (e) => {
      e.stopPropagation();
      document.documentElement.style.overflow = '';
      const id = dialog.getAttribute('data-strains-dialog');
      if (id) {
        const openBtn = /** @type {HTMLElement | null} */ (document.querySelector(`[data-strains-id='${id}'][data-strains-open]`));
        if (openBtn) {
          // Use setTimeout to ensure dialog is fully closed before focusing
          setTimeout(() => {
            openBtn.focus();
          }, 0);
        }
      }
    });
    
    // Handle backdrop clicks (clicking outside the dialog)
    dialog.addEventListener('click', (event) => {
      const target = /** @type {HTMLElement | null} */ (event.target);
      if (target === dialog) {
        // Clicked on the backdrop - close the dialog
        event.stopPropagation();
        if (dialog.open) {
          dialog.close();
        }
        // Focus and overflow handled in close event
      }
    });
  });
});

export {};